<template>

  <v-app>
    <v-navigation-drawer
      app
      v-model='drawer'
      temporary
      >
      <v-card class="mx-auto">

        <v-card-title class='px-0 py-0'>
          <v-toolbar
            color="deep-purple"
          >
          <v-app-bar-nav-icon @click="drawer=!drawer" alt="Hot Linux">
          </v-app-bar-nav-icon>

            <a href="/" style='color:white;text-decoration:none;'>Hot Linux</a>
          </v-toolbar>
        </v-card-title>
        <v-card-text class='mt-0'>
          <v-list>
            <!-- <v-list-item-group> -->
              <v-list-item key="1" to="/" color='primary'>
                <v-list-item-title>
                  主なサービス
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-account-wrench-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="2" to="/flow" color='primary'>
                <v-list-item-title>
                  ご相談から納品まで
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-truck-check-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="3" to="/sales" color='primary'>
                <v-list-item-title>
                  販売商品
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-cart-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="4" to="/column" color='primary'>
                <v-list-item-title>
                  日々のコラム
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-calendar-month</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="5" to="/trackrecord" color='primary'>
                <v-list-item-title>
                  開発事例
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="6" to="/qanda" color='primary'>
                <v-list-item-title>
                  よくある質問
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-message-question-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="7" to="/customercomments" color='primary'>
                <v-list-item-title>
                  お客様の声
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-account-tie-voice-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="8" to="/inquiryform" color='primary'>
                <v-list-item-title>
                  お問い合わせ
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-email-edit-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="9" to="/businessinfo" color='primary'>
                <v-list-item-title>
                  事業者概要
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon color=''>mdi-map-marker-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="10" to="/privacypolicy" color='primary'>
                <v-list-item-title>
                  PrivacyPolicy
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-shield-key-outline</v-icon>
                </template>
              </v-list-item>
              <!--
              <v-list-item key="11" to="/repayment" color='primary'>
                <v-list-item-title>
                  返金について
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-arrow-u-left-top</v-icon>
                </template>
              </v-list-item>
              -->
              <v-divider></v-divider>
              <v-list-item key="12" href="https://hot-linux.app/" target='sample' color='primary'>
                <v-list-item-title>
                  システム例
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.pro/" target='sample' color='primary'>
                <v-list-item-title>
                  代表の想い
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.jp/" target='service' color='primary'>
                <v-list-item-title>
                  人気サービス
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.net/" target='gce' color='primary'>
                <v-list-item-title>
                  GCEのメリット
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
            <!-- </v-list-item-group> -->
          </v-list>
        </v-card-text>
      </v-card>
      <!-- <v-btn to="/admin">管理</v-btn> -->
    </v-navigation-drawer>
    <v-app-bar
      app
      color="deep-purple"
      elevation="4"
    >

      <v-app-bar-nav-icon @click="drawer=!drawer">

      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <a href="/" style='color:white;text-decoration:none;'>Hot Linux ／ WEBシステム開発</a>

      </v-toolbar-title>

      <v-toolbar-items class='mr-5'>

      お客様に合わせた<br>
      柔軟なシステム開発
      </v-toolbar-items>

    </v-app-bar>
    <v-main
      app
    >
      <router-view
        @overlay='toggle_overlay()'
        class='mb-5'
      ></router-view>
      <v-snackbar
        position='sticky'
        v-model="snackbar"
        timeout="-1"
        color="lime-accent-3"
        dense
      >
      <!--
        <v-btn
          flat
          block
          to="/inquiryform"
          @click='show簡易問い合わせ=true'
        >ご相談・お問い合わせ（Slack・メール）
        </v-btn>
        -->
        <v-btn
          flat
          block
          dense
          @click='onClick簡単問合せ()'
          class="lime-accent-3 font-weight-bold"
          color="lime-accent-3"
        >簡単お問い合わせ（メール・Slack・Chatwork・LINE）
        </v-btn>
      </v-snackbar>
      <v-dialog
        max-width='800'
        v-model='show簡単問い合わせ'
      >
        <v-card>
          <v-card-title
            class='primary'
          >
            簡単お問い合わせ（メールアドレスだけでご相談受付ができます）
          </v-card-title>
          <v-card-text
            class="overflow-y-auto"
          >
            <v-form v-model='valid' ref=mailForm>
              <v-text-field
                label='メールアドレス'
                v-model='メールアドレス'
                :rules="emailRules"
                variant="outlined"
              ></v-text-field>

              <v-divider
                class='my-5'
              ></v-divider>
              <v-row>
                <v-col>
                  ご希望のお問い合わせ方法
                </v-col>
              </v-row>
            </v-form>
            <v-radio-group v-model='返信形式'>
              <v-row>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='メール'
                    label='メール'></v-radio>
                <span class='text-caption'>入力したメールアドレスに問い合わせ用のメールテンプレートが届きます。そのメールにお問い合わせ内容を記入して返信してください</span>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='Slack'
                    label='Slack'></v-radio>
                    <span class='text-caption'>入力したメールアドレスをSlack（チャットツール）のDMに招待いたします。</span>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='Chatwork'
                    label='Chatwork'></v-radio>
                    <span class='text-caption'>入力したメールアドレスをChatwork（チャットツール）のDMに招待いたします。</span>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-btn
              :disabled='!valid'
              block
              class='mb-4'
              color='primary'
              @click='onClick送信()'
            >
              送信する
            </v-btn>
            <v-row class='my-5'>
              <v-col>
                <v-divider
              
                ></v-divider>
              </v-col>
              <v-col cols='auto'>
                または
              </v-col>
              <v-col>
                <v-divider
                ></v-divider>
              </v-col>
            </v-row>
            <v-btn
              block
              color="success"
              @click='onClickLine()'
              >LINEで相談する</v-btn>
            <v-btn
              class='mt-10'
              block

              @click='show簡単問い合わせ=false'
              >閉じる</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
    <v-footer
      app
       class="d-flex flex-column"
       color="deep-purple"
      >
      <div class='w-100 text-right'>
        Copyright 2024 <a href="/" style='color:white;text-decoration:none;'>Hot Linux</a>
      </div>
      
    </v-footer>
    <loading
      v-model:active="overlay"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
  </v-app>
</template>

<script>

import Loading from 'vue-loading-overlay'
export default {
  name: 'App',
  components: {
    Loading
  },
  data:()=>({
      selectedItem:0,
      drawer:false,
      snackbar:true,
      overlay:false,
      fullPage:true,
      show簡単問い合わせ:false,
      返信形式:'メール',
      メールアドレス:"",
      valid:false,

      emailRules:[
        v => !!v || "必須です",
        v => /.+@.+/.test(v) || '形式が違います',
      ],
    }),

  methods:{
    toggle_overlay:function(){
      this.overlay = !this.overlay;
    },

    onClick簡単問合せ(){
      this.show簡単問い合わせ = true;
      this.$gtag.event("conversion",{
        'send_to':'AW-10896111516/LkydCImpjqIZEJzv1cso',
        'value':1,
        'currency':'JPN'
      })
    },

    onClick送信(){
      //this.$emit('overlay');
      this.toggle_overlay();
      let url = '../api/api.php';
      let data = {
        func:"簡単問い合わせ保存",
        メールアドレス:this.メールアドレス,
        返信形式:this.返信形式,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        console.log("相談result",result);
        this.confirmDialog = false;
        this.$refs.mailForm.reset();
        this.返信形式 = "Slack"
        this.$emit('overlay');
        alert("ご相談ありがとうございます。一両日中にはご希望の返信形式で返信いたします。少々お待ちください。");
      })
      .catch(error =>{
        alert('送信できませんでした。\n\n'+error.body);
        console.log("相談error",error)
        //this.$emit('overlay');
      })
      .finally(() => {
        this.toggle_overlay()
      })
      this.confirmDialog = false;


    },

    onCancel(){

    },

    onClickLine(){
      window.open("https://lin.ee/XRhQTGa")
    }
  }
}
</script>



<style>


#app {
  font-family: "M PLUS Rounded 1c","M PLUS 2","Kosugi Maru",Avenir, Helvetica, Arial, sans-serif;
  /*
  font-family: "M PLUS 1p","Kiwi Maru","M PLUS Rounded 1c","M PLUS 2","Kosugi Maru",Avenir, Helvetica, Arial, sans-serif;
  */

  /*
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  */
}
</style>
